import { render, staticRenderFns } from "./bar-element.vue?vue&type=template&id=5288fe70&"
import script from "./bar-element.vue?vue&type=script&lang=js&"
export * from "./bar-element.vue?vue&type=script&lang=js&"
import style0 from "./bar-element.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports